
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import radioControlComponent from './radio-control.component';

let radioControlModule = angular.module('radio-control', [
  uiRouter
])

.component('radioControl', radioControlComponent)

.name;

export default radioControlModule;



// WEBPACK FOOTER //
// ./client/app/common/radio-control/radio-control.js